import { createMerchantClient } from '@beatq/sdk';
import { csrfHeaders, getAccessToken } from '@beatq/shared';
import { getApiBaseUrl } from './config.js';
export function getMerchantClient() {
    return createMerchantClient({
        baseUrl: getApiBaseUrl(),
        credentials: 'include',
        accessToken: getAccessToken() ?? undefined,
        headers: csrfHeaders(),
    });
}
//# sourceMappingURL=merchant.js.map